import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { checklistsService } from '../api/checklists.service';
import { CHECKLIST_KEYS } from './queryKeys';
import type { CreateChecklistPayload, UpdateChecklistPayload } from '../types';

export function useCreateChecklist(taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (data: CreateChecklistPayload) => checklistsService.create(taskId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CHECKLIST_KEYS.byTask(orgId ?? '', taskId) });
    },
  });
}

export function useUpdateChecklist(taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: ({ checklistId, data }: { checklistId: string; data: UpdateChecklistPayload }) =>
      checklistsService.update(checklistId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CHECKLIST_KEYS.byTask(orgId ?? '', taskId) });
    },
  });
}

export function useDeleteChecklist(taskId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (checklistId: string) => checklistsService.delete(checklistId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CHECKLIST_KEYS.byTask(orgId ?? '', taskId) });
    },
  });
}
